import styled from 'styled-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

export const LoadingSpinnerWrapper = styled.div<{
	color: string;
	isScreenshot: boolean;
}>`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	position: ${(props) => (props.isScreenshot ? 'static' : 'absolute')};
	top: ${(props) => (props.isScreenshot ? 'auto' : 0)};
	background-color: ${(props) =>
		props.color === 'white'
			? SkapaTheme.color.background.default
			: SkapaTheme.color.background.alt};
	z-index: 1000;
`;
